/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { CaseUrgentResponseJson } from './case-urgent-response-json';
import { CaseUrgentUpdateResult } from '../results/case-urgent-update-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class CaseUrgentResponse extends ResponseWithErrorGeneric<CaseUrgentResponseJson, CaseUrgentUpdateResult> implements IResponseWithErrorGeneric<CaseUrgentUpdateResult> {
  public caseId: string = undefined;
  public urgent: boolean;

  //<custom-body>
  constructor(response: HttpResponse<CaseUrgentResponse>) {
    super(response, CaseUrgentUpdateResult.Error);
    if (this.result === CaseUrgentUpdateResult.Success) {
      this.caseId = this.body.caseId;
      this.urgent = this.body.urgent;
    }
  }
  //</custom-body>
}
